import { getAnalyticsClickHandler } from '@eventbrite/legacy-infra.site-analytics';
import { gettext } from '@eventbrite/legacy-infra.i18n';
import {
    ACTION_HOST_AN_EVENT_CLICK,
    ACTION_HOST_AN_EVENT_HOVER,
    CATEGORY_HEADER,
    UI_BLUE,
} from '../constants/tracking';
import { ANCHOR_LINK } from '@eventbrite/legacy-eds.nav-list-item/constants';

/**
 * Gets info to generate Organizer menu item usually passed `additionalMenus` prop of EDS Global Header
 * @param {object} organizeUrls
 * @param {UrlInfo} organizeUrls.home
 * @param {UrlInfo[]} organizeUrls.suggested
 * @param {string} [requestPath] Current request path (for analytics)
 * @returns {object}
 */
export const getOrganizeMenu = ({ home: { url: homeUrl }, suggested }, requestPath) => {
    const suggestedOrganizeMenuItems = suggested.map(
        ({ url, gaLabel, label, accentLink = false }) => {
            const style = accentLink ? { color: UI_BLUE } : {};
            const link = {
                type: ANCHOR_LINK,
                path: url,
                style,
                content: label,
                onClick: getAnalyticsClickHandler({
                    requestPath,
                    action: ACTION_HOST_AN_EVENT_CLICK,
                    category: CATEGORY_HEADER,
                    label: gaLabel,
                }),
                onMouseLeave: getAnalyticsClickHandler({
                    action: ACTION_HOST_AN_EVENT_HOVER,
                    category: CATEGORY_HEADER,
                    label: gaLabel,
                }),
            };
            return link;
        },
    );
    const navItems = [...suggestedOrganizeMenuItems];

    return {
        label: gettext('Organize').toString(),
        fallbackUrl: homeUrl,
        navItems,
    };
};
